export const SUCCESS_MESSAGE = "Record has been saved successfully!";
export const UNDELETE_MESSAGE = "Record has been undeleted successfully!";
export const DELETE_MESSAGE = "Record has been deleted successfully!";
export const CLEANUP_MESSAGE = "Customer Cleaned successfully!";
export const ERROR_EXISTS = "Data already exists!";
export const ERROR_MESSAGE = "Something went wrong!";
export const NECESSARY_FIELD = "Please fill all Below Field- ";
export const ALREADY_EXIST = " already exist!"; // before space concate name of the field
export const Message_DATA =
  "You can not add this customer because supplier is already exist with the same Company name !";
export const Message_DATA3 =
  "You can not add this customer because customer is already exist with the same Company name !";
export const Message_DATA1 =
  "You can not add this supplier because Customer is already exist with the same Company name!";
export const Message_DATA2 =
  "You can not add this supplier because supplier is already exist with the same Company name!";
export const DATA_EXPORT = "Data exported successfully!";

export const ALL_NECESSARY_FIELD =
  "Personal Details, Address and Account Balance are mandatory field!";

// AWS Details
export const REACT_APP_AWSAccessKeyId = "AKIARSXGH5STDK3NVP6D"; // "AKIA435OP3722G24SQ6B";
export const REACT_APP_AWSSecretKey =
  "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"; //"Rr25AGMOWMMRnBoiPQiqxdwio/ktyqoCoxa4APds";
export const REACT_APP_Bucket = "sonar-production-bucket"; //"sonarposdev";
export const REACT_APP_REGION = "us-east-1"; //"us-west-1";
export const AWS_IMAGE_FOLDER_CATEGORIES = "CATEGORIES";
export const AWS_IMAGE_FOLDER_TAGS = "TAGS";
export const AWS_IMAGE_FOLDER_BRANDS = "BRANDS";
export const AWS_IMAGE_FOLDER_CUSTOMER = "CUSTOMERS";
export const AWS_IMAGE_FOLDER_EMPLOYEES = "EMPLOYEES";
export const AWS_IMAGE_FOLDER_SUPPLIERS = "SUPPLIERS";
export const AWS_IMAGE_FOLDER_DELIVERIES = "DELIVERIES";
export const AWS_IMAGE_FOLDER_LOCATIONS = "LOCATIONS";
export const AWS_IMAGE_FOLDER_STORECONFIG = "STORECONFIG";
export const AWS_IMAGE_FOLDER_WORKORDERS = "WORKORDERS";
export const AWS_IMAGE_FOLDER_ITEMS = "ITEMS";
export const AWS_IMAGE_FOLDER_ITEMKITS = "ITEMKITS";
export const AWS_IMAGE_FOLDER_SALES = "SALES";
export const AWS_IMAGE_FOLDER_RECEIVING = "RECEIVING";
export const AWS_IMAGE_FOLDER_BANNER = "BANNER";
export const AWS_IMAGE_FOLDER_FOOTERTOP = "FOOTERTOP";
export const AWS_IMAGE_FOLDER_MAINFOOTER = "MAINFOOTER";
export const AWS_IMAGE_FOLDER_ECOMCONFIG = "ECOMCONFIG";
export const AWS_IMAGE_FOLDER_POS = "POS";
 
export const CUSTOM_SELECT_DROPDOWN_RECEIPT_STYLE = {
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    position: "relative",
    border: state.isFocused
      ? "1px solid var(--primary-main-color)"
      : "1px solid var(--primary-color-100)",
    boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
    borderRadius: "var(--border-radius) !important",
    textAlign: "left", // Align text inside control
    justifyContent: "flex-start", // Align dropdown arrow and text to the left
  }),
  menu: () => ({
    boxShadow: "inset 0 1px 0 var(--primary-color-50)",
    position: "absolute",
    zIndex: "99999",
    background: "var(--primary-color-50)",
    width: "100%",
    textAlign: "left", // Align menu options to the left
  }),
  option: (provided, state) => ({
    ...provided,
    textAlign: "left", // Align text inside each option
    justifyContent: "flex-start", // Optional: helps with internal flex alignment
    color: state.isSelected
      ? "var(--primary-base-color)"
      : "var(--primary-color-800)",
    backgroundColor: state.isFocused
      ? "var(--primary-color-50)"
      : state.isSelected
      ? "var(--primary-main-color)"
      : "var(--primary-base-color)",
    '&:hover': {
      backgroundColor: "var(--primary-color-50)",
    },
  }),
};


/* common style class */
export const CUSTOM_SELECT_DROPDOWN_STYLE = {
  // dropdown input css
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    // height: "40px",
    position: "relative",
    border: state.isFocused
      ? "1px solid var(--primary-main-color)"
      : "1px solid var(--primary-color-100)", // add orange outline when hovering
    boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
    '&:hover': {
      border: state.isFocused
        ? "1px solid var(--primary-main-color)"
        : "1px solid var(--primary-color-100)", // add orange outline when hovering
    },
    borderRadius: "var(--border-radius) !important",
  }),
  // dropdown menu css
  menu: () => ({
    boxShadow: "inset 0 1px 0 var(--primary-color-50)",
    position: "absolute",
    'z-index': "99999",
    background: "var(--primary-color-50)",
    width: "100%",
  }),
  // dropdown option css
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected
      ? "var(--primary-base-color)"
      : "var(--primary-color-800)",
    backgroundColor: state.isFocused
      ? "var(--primary-color-50)"
      : state.isSelected
      ? "var(--primary-color-50)"
      : "var(--primary-base-color)", // change hover color to light orange
    '&:hover': {
      backgroundColor: "var(--primary-color-50)", // change hover color to light orange
    },
  }),
};

export const CUSTOM_SELECT_DROPDOWN_STYLE_VIEW_VREGISTER = {
  // Control height
  control: (provided, state) => ({
    ...provided,
    height: "30px",
    minHeight: "30px",
    border: state.isFocused
      ? "1px solid var(--primary-main-color)"
      : "1px solid var(--primary-color-100)",
    boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
    "&:hover": {
      border: state.isFocused
        ? "1px solid var(--primary-main-color)"
        : "1px solid var(--primary-color-100)",
    },
    borderRadius: "2px !important",
    // borderRadius: "var(--border-radius) !important",
  }),

  // Adjust text container inside control
  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
    padding: "0 8px",
  }),

  // Adjust input box
  input: (provided) => ({
    ...provided,
    margin: "0px",
    padding: "0px",
  }),

  // Adjust the dropdown arrow container
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),

  // Dropdown menu
  menu: () => ({
    boxShadow: "inset 0 1px 0 var(--primary-color-50)",
    position: "absolute",
    zIndex: 99999,
    background: "var(--primary-color-50)",
    width: "auto",
  }),

  // Option styling
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected
      ? "var(--primary-base-color)"
      : "var(--primary-color-800)",
    backgroundColor: state.isFocused
      ? "var(--primary-color-50)"
      : state.isSelected
      ? "var(--primary-main-color)"
      : "var(--primary-base-color)",
    "&:hover": {
      backgroundColor: "var(--primary-color-50)",
    },
    height: "30px",         // Option height
    lineHeight: "30px",     // Vertically center text
    padding: "0 10px",      // Horizontal padding
  }),
};


export const CUSTOM_SELECT_DROPDOWN_STYLE_VIEW = {
  // dropdown input css
  control: (provided, state) => ({
    ...provided,
    width: "auto",
    // height: "40px",
    position: "relative",
    border: state.isFocused
      ? "1px solid var(--primary-main-color)"
      : "1px solid var(--primary-color-100)", // add orange outline when hovering
    boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
    "&:hover": {
      border: state.isFocused
        ? "1px solid var(--primary-main-color)"
        : "1px solid var(--primary-color-100)", // add orange outline when hovering
    },
    borderRadius: "var(--border-radius) !important",
  }),
  // dropdown menu css
  menu: () => ({
    boxShadow: "inset 0 1px 0 var(--primary-color-50)",
    position: "absolute",
    "z-index": "99999",
    background: "var(--primary-color-50)",
    width: "auto",
  }),
  // dropdown option css
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected
      ? "var(--primary-base-color)"
      : "var(--primary-color-800)",
    backgroundColor: state.isFocused
      ? "var(--primary-color-50)"
      : state.isSelected
      ? "var(--primary-main-color)"
      : "var(--primary-base-color)", // change hover color to light orange
    "&:hover": {
      backgroundColor: "var(--primary-color-50)", // change hover color to light orange
    },
  }),
};

export const CUSTOM_SELECT_DROPDOWN_STYLE_POS = {
  // dropdown input css
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    minWidth: "250px", 
    // height: "40px",
    position: "relative",
    // border
    border: state.isFocused
      ? "1px solid var(--primary-main-color)"
      : "1px solid var(--primary-color-100)", // add orange outline when hovering
    boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
    '&:hover': {
      border: state.isFocused
        ? "1px solid var(--primary-main-color)"
        : "1px solid var(--primary-color-100)", // add orange outline when hovering
    },
    borderRadius: "var(--border-radius) !important",
    borderBottomLeftRadius: "0px !important",
    borderTopLeftRadius: "0px !important",
  }),
  // dropdown menu css
  menu: () => ({
    boxShadow: "inset 0 1px 0 var(--primary-color-50)",
    position: "absolute",
    'z-index': "99999",
    background: "var(--primary-color-50)",
    width: "100%",
  }),
  // dropdown option css
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected
      ? "var(--primary-base-color)"
      : "var(--primary-color-800)",
    backgroundColor: state.isFocused
      ? "var(--primary-color-50)"
      : state.isSelected
      ? "var(--primary-main-color)"
      : "var(--primary-base-color)", // change hover color to light orange
    '&:hover': {
      backgroundColor: "var(--primary-color-50)", // change hover color to light orange
    },
  }),
};

export const CUSTOM_SELECT_DROPDOWN_STYLE_COMBINE = {
  // dropdown input css
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    height: "40px",
    position: "relative",
    border: state.isFocused
      ? "1px solid var(--primary-main-color)"
      : "1px solid var(--primary-color-100)", // add orange outline when hovering
    boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
    '&:hover': {
      border: state.isFocused
        ? "1px solid var(--primary-main-color)"
        : "1px solid var(--primary-color-100)", // add orange outline when hovering
    },
    borderRadius:
      "0px var(--border-radius) var(--border-radius) 0px !important",
  }),
  // dropdown menu css
  menu: () => ({
    boxShadow: "inset 0 1px 0 var(--primary-color-50)",
    position: "absolute",
    'z-index': "999",
    background: "var(--primary-color-50)",
    width: "100%",
  }),
  // dropdown option css
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected
      ? "var(--primary-base-color)"
      : "var(--primary-color-800)",
    backgroundColor: state.isFocused
      ? "var(--primary-color-50)"
      : state.isSelected
      ? "var(--primary-main-color)"
      : "var(--primary-base-color)", // change hover color to light orange
    '&:hover': {
      backgroundColor: "var(--primary-color-50)", // change hover color to light orange
    },
  }),
};